<!-- Modal Header -->
<div class="modal-header">
	<h4 class="modal-title">
		<i class="bi bi-image me-2" *ngIf="extractionMode === 'pdf'"></i>
		<i class="bi bi-globe me-2" *ngIf="extractionMode === 'url'"></i>
		<span *ngIf="extractionMode === 'pdf'">Poimi kuvat PDF-tiedostosta</span>
		<span *ngIf="extractionMode === 'url'">Poimi kuvat verkkosivulta</span>
	</h4>
	<button
		type="button"
		class="btn-close"
		aria-label="Close"
		(click)="cancel()"
	></button>
</div>

<!-- Modal Body -->
<div class="modal-body">
	<!-- Compact Progress Bar (shown while extracting) -->
	<div *ngIf="isExtracting" class="mb-3">
		<div class="d-flex align-items-center">
			<small class="text-muted me-2">
				<span *ngIf="extractionMode === 'pdf'">Etsitään kuvia PDF-tiedostosta...</span>
				<span *ngIf="extractionMode === 'url'">Ladataan kuvia verkkosivulta...</span>
			</small>
			<ngb-progressbar
				[value]="extractionProgress"
				[max]="100"
				type="primary"
				[striped]="true"
				[animated]="true"
				class="flex-grow-1"
				style="height: 0.5rem;"
			></ngb-progressbar>
		</div>
	</div>

	<!-- Error State -->
	<div *ngIf="!isExtracting && errorMessage" class="alert alert-info">
		<i class="bi bi-exclamation-triangle me-2"></i>
		{{ errorMessage }}
	</div>

	<!-- Images Grid (shown as soon as images are found) -->
	<div *ngIf="extractedImages.length > 0 && !errorMessage">
		<!-- Selection Controls -->
		<div class="d-flex justify-content-between align-items-center mb-3">
			<div class="form-check">
				<input
					class="form-check-input"
					type="checkbox"
					id="selectAll"
					[(ngModel)]="selectAll"
					(change)="toggleSelectAll()"
				/>
				<label class="form-check-label" for="selectAll">
					Valitse kaikki
				</label>
			</div>
			<div class="text-muted">
				{{ getSelectedCount() }} / {{ extractedImages.length }} kuvaa valittu
			</div>
		</div>

		<!-- Images Grid -->
		<div class="images-grid" *ngIf="extractedImages.length > 0" [@imageList]="extractedImages.length">
			<div
				*ngFor="let image of extractedImages; trackBy: trackByImageIndex"
				class="image-item"
				[class.selected]="image.selected"
				(click)="toggleImageSelection(image)"
			>
				<!-- Selection Checkbox -->
				<div class="selection-overlay">
					<div class="form-check">
						<input
							class="form-check-input"
							type="checkbox"
							[checked]="image.selected"
							(click)="$event.stopPropagation()"
							(change)="toggleImageSelection(image)"
						/>
					</div>
				</div>

				<!-- Preview Icon -->
				<div class="preview-overlay">
					<button
						type="button"
						class="btn btn-primary btn-sm"
						(click)="$event.stopPropagation(); previewImage(image)"
						title="Esikatsele kuvaa"
					>
						<i class="bi bi-eye"></i>
					</button>
				</div>

				<!-- Image Thumbnail -->
				<div class="image-thumbnail">
					<img
						[src]="image.dataUrl"
						[alt]="extractionMode === 'pdf' ? 'Kuva sivulta ' + image.pageNumber : 'Kuva verkkosivulta'"
						class="thumbnail-image"
						[class.failed-image]="image.failedToLoad"
					/>
					<!-- Failed to load overlay -->
					<div *ngIf="image.failedToLoad" class="failed-overlay">
						<i class="bi bi-exclamation-triangle text-warning"></i>
					</div>
				</div>

				<!-- Image Info -->
				<div class="image-info">
					<small class="text-muted" *ngIf="extractionMode === 'pdf'">
						Sivu {{ image.pageNumber }}
					</small>
					<small class="text-muted" *ngIf="extractionMode === 'url' && image.sourceUrl">
						{{ getUrlDomain(image.sourceUrl) }}
					</small>
					<br />
					<small class="text-muted">
						{{ getThumbnailDimensions(image) }}
						<span
							*ngIf="image.width < 500 || image.height < 500"
							ngbTooltip="Kuva on pienikokoinen. Kuvan ei välttämättä näytä laadukkaalta kaikissa käyttötarkoituksissa."
							placement="top"
							[openDelay]="500"
						>
							<i class="bi bi-exclamation-triangle text-warning ms-1"></i>
						</span>
					</small>
					<br *ngIf="image.failedToLoad" />
					<small class="text-warning" *ngIf="image.failedToLoad">
						Lataus epäonnistui
					</small>
				</div>
			</div>
		</div>

	</div>

	<!-- No Images Found Yet (while still extracting) -->
	<div *ngIf="extractedImages.length === 0 && isExtracting && !errorMessage" class="text-center py-4">
		<i class="bi bi-search text-muted" style="font-size: 2rem;"></i>
		<p class="text-muted mt-2">
			<span *ngIf="extractionMode === 'pdf'">Etsitään kuvia PDF-tiedostosta...</span>
			<span *ngIf="extractionMode === 'url'">Ladataan kuvia verkkosivulta...</span>
		</p>
	</div>

	<!-- No Images Found (extraction complete) -->
	<div *ngIf="extractedImages.length === 0 && !isExtracting && !errorMessage && hasExtracted" class="text-center py-4">
		<i class="bi bi-image text-muted" style="font-size: 3rem;"></i>
		<h5 class="mt-3 text-muted">Ei kuvia löytynyt</h5>
		<p class="text-muted">
			<span *ngIf="extractionMode === 'pdf'">PDF-tiedostosta ei löytynyt purettavia kuvia.</span>
			<span *ngIf="extractionMode === 'url'">Verkkosivulta ei löytynyt ladattavia kuvia.</span>
		</p>
	</div>
</div>

<!-- Modal Footer -->
<div class="modal-footer">
	<button
		type="button"
		class="btn btn-outline-secondary"
		(click)="cancel()"
	>
		Peruuta
	</button>
	<button
		type="button"
		class="btn btn-primary"
		[disabled]="getSelectedCount() === 0"
		(click)="confirmSelection()"
	>
		Poimi valitut kuvat
	</button>
</div>